import { createContext, useContext } from "react"

export type GraphIntervalType = "year" | "month" | "all"

export const AvailableDatePeriods = {
	DAY: "day",
	MONTH: "month",
	YEAR: "year",
	ALL: "all",
}

export type ProductionGraphContextType = {
	graphInterval: "day" | "month"
	setGraphInterval(graphInterval: "day" | "month"): void
	startTime: any
	setStartTime(startTime: any): void
	endTime: any
	setEndTime(endTime: any): void
	knmiDataStatus: "included" | "excluded" | null
	setKnmiDataStatus(
		knmiDataStatus: ProductionGraphContextType["knmiDataStatus"],
	): void
}

export const ProductionGraphContext = createContext<ProductionGraphContextType>(
	null!,
)

export function useProductionGraphContext() {
	const context = useContext(ProductionGraphContext)

	if (!context) {
		throw new Error(
			"ProductionGraphContext must be used within a ProductionGraphContextProvider",
		)
	}

	return context
}
